import { createAsyncThunk } from '@reduxjs/toolkit';
import createGenericSlice, { GenericState } from '../wrapper/sliceWrapper';
import RepoOwnerService from '../../utils/RepoOwner/RepoOwner';
import IRepoOwner from '../../utils/RepoOwner/RepoOwner.interface';

interface IActionType {
  payload: IRepoOwner;
  type: string;
}

interface IUpdateActionType {
  payload: { original: string; updated: IRepoOwner };
  type: string;
}

interface IOwnerCountAction {
  payload: { ownerName: string; delta: number };
  type: string;
}

const initialState: GenericState<Array<IRepoOwner> | null> = { data: null, status: 'loading' };

export const getAllRepoOwners = createAsyncThunk('repoOwners/getAllRepoOwners', async () => {
  const service = new RepoOwnerService();
  return await service.getAllRepoOwners();
});

const repoOwnerSlice = createGenericSlice({
  name: 'repoOwners',
  initialState,
  reducers: {
    addRepoOwner: (state, action: IActionType) => {
      if (state.data) {
        state.data.push(action.payload);
      } else {
        state.data = [action.payload];
      }
    },
    removeRepoOwner: (state, action: IActionType) => {
      state.data = state.data
        ? state.data.filter((item) => item.repoOwnerName !== action.payload.repoOwnerName)
        : state.data;
    },
    updateRepoOwnerState: (state, action: IUpdateActionType) => {
      state.data = state.data
        ? state.data.map((item) =>
            item.repoOwnerName === action.payload.original ? action.payload.updated : item
          )
        : state.data;
    },
    updateRepoOwnerCount: (state, action: IOwnerCountAction) => {
      if (state.data) {
        const owner = state.data.find((o) => o.repoOwnerName === action.payload.ownerName);
        if (owner) {
          owner.noOfRepository = (owner.noOfRepository ?? 0) + action.payload.delta;
        }
      }
    },
    resetRepoOwnerState: (state) => {
      state.data = null;
      state.status = 'loading';
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getAllRepoOwners.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(getAllRepoOwners.fulfilled, (state, action) => {
      state.status = 'finished';
      state.data = action.payload;
    });
    builder.addCase(getAllRepoOwners.rejected, (state) => {
      state.status = 'error';
      state.error = 'Failed to fetch repo owners.';
    });
  }
});

export const { addRepoOwner, removeRepoOwner, updateRepoOwnerState, updateRepoOwnerCount, resetRepoOwnerState } =
  repoOwnerSlice.actions;
export default repoOwnerSlice.reducer;
